import React from 'react'

const TermsContent: React.FC = () => {
  return (
    <div className="text-gray-700 text-sm leading-relaxed">

      <h3 className="text-lg font-bold text-gray-900 mb-4">1. TÉRMINOS Y CONDICIONES DE USO</h3>
      <p className="mb-2 text-xs text-gray-500">Última actualización: Enero 2025</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.1 Aceptación de los Términos</h4>
      <p className="mb-4">
        Al acceder, registrarse o utilizar la plataforma InnovaAgent, operada por Rubén Rodríguez González
        (persona física, nombre comercial InnovaAgent, en adelante "El Responsable"), el usuario acepta
        cumplir estos Términos y Condiciones. Si no está de acuerdo, deberá abstenerse de utilizar la plataforma.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.2 Definiciones</h4>
      <p className="mb-4">
        <strong>Plataforma / InnovaAgent:</strong> Ecosistema inteligente inmobiliario operado bajo el nombre comercial InnovaAgent.<br/>
        <strong>Usuario / Agente:</strong> Persona física o moral que accede, crea una cuenta o utiliza los servicios.<br/>
        <strong>Contenido:</strong> Información, datos, textos, imágenes, propiedades, anuncios o materiales generados por la plataforma o el usuario.<br/>
        <strong>Servicios:</strong> Todas las herramientas tecnológicas ofrecidas por InnovaAgent.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.3 Objeto del Servicio</h4>
      <p className="mb-4">
        InnovaAgent proporciona herramientas tecnológicas para que agentes y desarrolladores inmobiliarios
        gestionen clientes, propiedades y campañas digitales mediante herramientas asistidas por IA.
        InnovaAgent no es una agencia inmobiliaria, ni participa como intermediario en operaciones de compraventa o renta.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.4 Registro y Cuenta del Usuario</h4>
      <p className="mb-4">
        Para utilizar la plataforma, el usuario debe: proporcionar información veraz y actualizada,
        ser mayor de 18 años, mantener la confidencialidad de su cuenta y contraseña, y notificar
        cualquier acceso no autorizado.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.5 Uso Permitido y Prohibido</h4>
      <p className="mb-2"><strong>Permite:</strong> Gestionar clientes, propiedades y anuncios; utilizar herramientas de segmentación y análisis; subir información inmobiliaria real y legal.</p>
      <p className="mb-4"><strong>Prohíbe:</strong> Publicar información falsa o fraudulenta; usar la plataforma para actividades ilícitas; vulnerar derechos de terceros; extraer datos mediante scraping o ingeniería inversa.</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.6 Propiedad Intelectual</h4>
      <p className="mb-4">
        Todo el software, diseño, logos, código y funcionalidades de InnovaAgent son propiedad exclusiva
        de Rubén Rodríguez González bajo el nombre comercial InnovaAgent.
        Los usuarios no adquieren derechos de propiedad sobre la plataforma.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.7 Disponibilidad del Servicio</h4>
      <p className="mb-4">
        InnovaAgent se esfuerza por mantener la plataforma operativa, pero no garantiza disponibilidad
        ininterrumpida debido a mantenimiento, actualizaciones o fallas técnicas.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.8 Responsabilidad Limitada</h4>
      <p className="mb-4">
        El Responsable no será responsable por pérdida de información por causas ajenas, contenidos
        generados por usuarios, o resultados comerciales derivados del uso de la plataforma.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.9 Cancelación de Cuenta</h4>
      <p className="mb-4">
        El usuario puede cancelar su cuenta en cualquier momento. InnovaAgent puede suspender o
        eliminar cuentas que violen estos Términos.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">1.10 Legislación Aplicable</h4>
      <p className="mb-4">
        Estos términos se rigen por la legislación vigente en Coahuila, México.
      </p>

      <h3 className="text-lg font-bold text-gray-900 mb-4 mt-10 pt-6 border-t">2. AVISO DE PRIVACIDAD</h3>
      <p className="mb-4">
        El tratamiento de datos personales se realiza conforme a la LFPDPPP. Para consultar el Aviso
        de Privacidad completo visita:{' '}
        <a href="/privacy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
          innovagent.tech/privacy
        </a>
      </p>

      <h3 className="text-lg font-bold text-gray-900 mb-4 mt-10 pt-6 border-t">3. POLÍTICAS DE USO</h3>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">3.1 Acceso a la Plataforma</h4>
      <p className="mb-2"><strong>Acceso permitido:</strong> Crear cuenta, registrar propiedades y leads, usar herramientas de IA y automatización.</p>
      <p className="mb-4"><strong>Acceso no permitido:</strong> Compartir credenciales, crear cuentas falsas, acceder con identidades falsas.</p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">3.2 Uso Adecuado de los Contenidos</h4>
      <p className="mb-4">
        El usuario se compromete a publicar únicamente información veraz sobre propiedades y gestionar
        leads de manera ética. Queda prohibido publicar información fraudulenta o utilizar datos de
        clientes sin autorización.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">3.3 Uso de Herramientas de IA</h4>
      <p className="mb-4">
        Está prohibido utilizar la IA para acosar, manipular o engañar clientes, o generar contenido
        falso o fraudulento.
      </p>

      <h4 className="font-semibold text-gray-800 mt-4 mb-2">3.4 Suspensión de Cuentas</h4>
      <p className="mb-4">
        InnovaAgent podrá suspender cuentas por actividades ilícitas, violaciones a estas políticas
        o suplantación de identidad. Se notificará al usuario antes de una suspensión permanente.
      </p>

      <h3 className="text-lg font-bold text-gray-900 mb-4 mt-10 pt-6 border-t">4. CONSENTIMIENTO INFORMADO</h3>
      <p className="mb-4">Al registrarse en InnovaAgent, el usuario reconoce y acepta que:</p>
      <ol className="list-decimal list-inside mb-4 space-y-2">
        <li>Ha leído y acepta los <strong>Términos y Condiciones de Uso</strong>.</li>
        <li>Ha leído y acepta el <strong>Aviso de Privacidad</strong> conforme a la LFPDPPP.</li>
        <li>Autoriza a InnovaAgent a crear su cuenta y tratar sus datos para las finalidades descritas.</li>
        <li>Reconoce el uso de <strong>herramientas de inteligencia artificial</strong> en la plataforma.</li>
        <li>Autoriza el uso de <strong>cookies y tecnologías de rastreo</strong>.</li>
        <li>Entiende que sus datos <strong>no serán vendidos ni comercializados</strong> con terceros.</li>
        <li>Reconoce su derecho a ejercer los <strong>derechos ARCO</strong> en contacto@bdctech.com.mx</li>
        <li>Declara que toda la información proporcionada será <strong>veraz y actualizada</strong>.</li>
      </ol>

      <div className="bg-blue-50 p-4 rounded-lg mt-6 mb-4">
        <p className="text-blue-800 font-medium text-center text-sm">
          Al seleccionar "Acepto y Crear Cuenta", otorgas tu consentimiento expreso.
        </p>
      </div>

      <p className="text-center text-gray-600 text-sm">
        <strong>Responsable:</strong> Rubén Rodríguez González · Nombre comercial: InnovaAgent<br/>
        Coahuila, México · contacto@bdctech.com.mx
      </p>

    </div>
  )
}

export default TermsContent
